import { render, staticRenderFns } from "./payGuide.vue?vue&type=template&id=4922a93d&scoped=true"
import script from "./payGuide.vue?vue&type=script&lang=js"
export * from "./payGuide.vue?vue&type=script&lang=js"
import style0 from "./payGuide.vue?vue&type=style&index=0&id=4922a93d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4922a93d",
  null
  
)

export default component.exports